import { useState, useEffect } from "react";
import HubblePageContainer from "./components/HubblePageContainer";
import { useNavigate } from "react-router";
import useDebounce from "../../assets/Hooks/useDebounce";

import { FaArrowLeftLong } from "react-icons/fa6";
import ArbitratoinFilters from "./components/ArbitratoinFilters";
import ArbitrationSearch from "./components/ArbitrationSearch";
import UploadsArbirtionElement from "./components/UploadsArbitrantionElement";
import Loading from "../../assets/containers/loadingDialog";
import errorHandler from "../../assets/utils/ErrorHandler";
import { getRefereeList } from "../../assets/services/apiServices";

const UploadsArbitration = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [refereeList, setRefereeList] = useState([]);
  const [activeFilter, setactiveFilter] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  useEffect(() => {
    getlist();
  }, [activeFilter, debouncedSearchTerm]);

  const getlist = async () => {
    try {
      const response = await getRefereeList(
        activeFilter === "All" ? false : true,
        debouncedSearchTerm
      );
      setRefereeList(response.data.hubbleFormList);
      setLoading(false);
    } catch (err) {
      errorHandler(err);
      setLoading(false);
    }
  };

  return (
    <HubblePageContainer>
      <div className="d-flex justify-content-between align-items-center py-2">
        <h4>داوری</h4>
        <div onClick={() => navigate(-1)}>
          <FaArrowLeftLong size={20} />
        </div>
      </div>
      <div className="mt-4">
        <ArbitratoinFilters
          active={activeFilter}
          handleChange={(val) => {
            setSearchTerm("");
            setactiveFilter(val);
          }}
        />
        <ArbitrationSearch
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
      </div>
      <div className="mt-5">
        {loading ? (
          <div className="d-flex justify-content-center">
            <Loading />
          </div>
        ) : (
          refereeList.map((item) => (
            <UploadsArbirtionElement
              data={item}
              key={item._id}
              refereed={activeFilter !== "All"}
            />
          ))
        )}
        {refereeList.length === 0 && (
          <div className="d-flex justify-content-center">
            موردی برای نمایش وجود ندارد
          </div>
        )}
      </div>
    </HubblePageContainer>
  );
};

export default UploadsArbitration;
